import AppPageForm from "./AppPageForm";

import "./AppPageForm.scss";

export { AppPageForm };
